import { ViewStyle } from 'react-native'
import { createUseStyles } from '../../styles/create-use-styles'
import type { BorderSeparatorProps } from './border-separator.props'

interface BorderSeparatorStyles {
  container: ViewStyle
}

export const useStyles = createUseStyles<BorderSeparatorStyles, BorderSeparatorProps>(
  (theme, props): BorderSeparatorStyles => {
    const { noMargin, borderColor = theme.colors.borderColor, direction = 'horizontal' } = props
    const isHorizontal = direction === 'horizontal'

    return {
      container: {
        minWidth: isHorizontal ? '100%' : undefined,
        minHeight: !isHorizontal ? '100%' : undefined,
        borderBottomWidth: isHorizontal ? theme.calcUnit(1) : theme.calcUnit(0),
        borderBottomColor: isHorizontal ? borderColor : undefined,
        borderRightWidth: !isHorizontal ? theme.calcUnit(1) : theme.calcUnit(0),
        borderRightColor: !isHorizontal ? borderColor : undefined,
        marginBottom: noMargin || !isHorizontal ? undefined : theme.calcUnit(theme.spacing.s2),
        marginRight: noMargin || isHorizontal ? undefined : theme.calcUnit(theme.spacing.s2),
      },
    }
  }
)
